import { NavLink } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";

const linkCls = ({ isActive }) =>
  `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition ${
    isActive ? "bg-white/5 text-white" : "text-slate-400 hover:text-white hover:bg-white/5"
  }`;

/** Desktop: one dropdown per navigation group. */
export function NavGroup({ group }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={`nav-group-${group.key}`}
          className="flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-slate-400 hover:text-white hover:bg-white/5 transition">
          <group.icon className="h-4 w-4" />
          {group.label}
          <ChevronDown className="h-3.5 w-3.5 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="bg-[#161923] border-white/10 text-slate-200 min-w-56">
        {group.items.map((n) => (
          <DropdownMenuItem key={n.to} asChild className="focus:bg-white/5 focus:text-white cursor-pointer p-0">
            <NavLink to={n.to} end={n.end} data-testid={n.testId} className={linkCls}>
              <n.icon className="h-4 w-4" />
              {n.label}
            </NavLink>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

/** Mobile: collapsible section per group. */
export function NavGroupMobile({ group, open, onToggle, onNavigate }) {
  return (
    <div className="border-b border-white/5 last:border-0">
      <button data-testid={`mobile-nav-group-${group.key}`} onClick={onToggle}
        className="w-full flex items-center gap-2 px-3 py-3 text-sm font-semibold text-slate-200">
        <group.icon className="h-4 w-4 text-slate-400" />
        {group.label}
        <ChevronDown className={`h-4 w-4 ml-auto opacity-60 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="pb-2 pl-3 flex flex-col gap-1">
          {group.items.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`m-${n.testId}`} onClick={onNavigate} className={linkCls}>
              <n.icon className="h-4 w-4" />
              {n.label}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}
